// Senior Management is a branch off the AML stage, not a stage of its own:
// allow_to_skip is honoured by nothing in this UI, so a third config row would
// strand every policy waiting for a manager.
//
// The labels below must match the partner's configured sequence exactly —
// maker_check_label is an exact match on the server, and check rows snapshot
// their label at purchase, so renaming a stage orphans every policy created
// before the rename.
import { getCurrentPendingCheck } from '../../../components/RecentPolicies/Components/makerCheckStage'
import { screeningFlagPrefix } from '../../AccessBank/PoliciesProcessing/lib/flaggedPolicyDecision'

export const ESCALATED_KEY = 'escalated_to_management'
export const MANAGEMENT_OUTCOME_KEY = 'management_outcome'

export const MANAGEMENT_REJECTED = 'rejected'

// Every desk query keys off this one stage: a policy is the AML desk's while it
// is Pending and New Business's once it is Approved, so the New Business label
// never has to be named here — which is just as well, since it is the one that
// keeps changing.
export const AML_STAGE_LABEL = 'AML Approval'

function details(policy) {
  return (policy && policy.additional_details) || {}
}

export function isEscalatedToManagement(policy) {
  return details(policy)[ESCALATED_KEY] === true
}

export function wasRejectedByManagement(policy) {
  return details(policy)[MANAGEMENT_OUTCOME_KEY] === MANAGEMENT_REJECTED
}

export function needsAction(policy) {
  return details(policy).need_action === true
}

export function isAmlStageCurrent(policy) {
  return screeningFlagPrefix(getCurrentPendingCheck(policy)) === 'aml'
}

export function isAwaitingAmlReview(policy) {
  return (
    isAmlStageCurrent(policy) &&
    !isEscalatedToManagement(policy) &&
    !needsAction(policy)
  )
}

export function isAwaitingManagementReview(policy) {
  return isEscalatedToManagement(policy) && !needsAction(policy)
}

export function isAwaitingNewBusinessReview(policy) {
  const current = getCurrentPendingCheck(policy)
  if (!current) {
    return false
  }
  return (
    screeningFlagPrefix(current) !== 'aml' &&
    !isEscalatedToManagement(policy) &&
    !needsAction(policy)
  )
}
